// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"405":"03715117","480":"03715117","815":"03715117"}[chunkId] + ".chunk.css";
};